import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Profile/index"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Charts
import ChartsAppex from "../pages/Charts/charts-appex";
import ChartsJs from "../pages/Charts/charts-chartjs";
import ChartsKnob from "../pages/Charts/charts-knob";
import ChartsSparkLine from "../pages/Charts/charts-sparkline";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import Iconion from "../pages/Icons/Iconion"
import IconFontawesome from "../pages/Icons/IconFontawesome"
import IconThemify from "../pages/Icons/IconThemify"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"

// Forms
import FormElements from "../pages/Forms/FormElements"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormUpload from "../pages/Forms/FormUpload"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiBadge from "../pages/Ui/UiBadge"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiPagination from "../pages/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline";
import PagesInvoice from "../pages/Extra Pages/pages-invoice";
import PagesDirectory from "../pages/Extra Pages/pages-directory";
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import UiUtilities from "pages/Ui/UiUtilities"
import UiColors from "pages/Ui/UiColors"
import UiOffcanvas from "pages/Ui/UiOffcanvas"
import Chat from "pages/Chat/Chat";
import Kanban from "pages/Kanban"
import Companies from "pages/Admin/Companies"
import Plans from "pages/Admin/Plans"
import SystemUsers from "pages/Admin/SystemUsers"
import Roles from "pages/Admin/Roles"
import Invoices from "pages/Admin/Invoices"
import Settings from "pages/Admin/Settings"
import SystemSettings from "../pages/Admin/Settings/index"
import TicketsList from "../pages/Admin/Tickets/index"
import TicketDetail from "../pages/Admin/Tickets/TicketDetail"
import SalesDashboard from "../pages/Dashboard/Admin/SalesDashboard"
import CompanyDetail from "pages/Admin/Companies/CompanyDetail"
import Permissions from "../pages/Admin/Permissions"

import Customers from "../pages/Customers/index"
import CustomerDetail from "../pages/Customers/CustomerDetail"
import CompanyUsers from "../pages/CompanyUsers/index"
import InvoicesList from "../pages/Invoices/index"
import InvoiceDetail from "../pages/Invoices/InvoiceDetail"
import InvoiceCreate from "../pages/Invoices/InvoiceCreate"
import PaymentsList from "../pages/Payments/index"
import ProductsList from "../pages/Products/index"
import QuotesList from "../pages/Quotes/index"
import QuoteCreate from "../pages/Quotes/QuoteCreate"
import QuoteDetail from "../pages/Quotes/QuoteDetail"
import SupportTickets from "../pages/Support/Tickets"
import SupportTicketDetail from "../pages/Support/TicketDetail"
import SuppliersList from "../pages/Suppliers/index"
import SupplierInvoices from "../pages/Suppliers/SupplierInvoices"
import PendingSubscriptions from "../pages/Admin/Subscriptions/PendingSubscriptions"
import WhatsAppPage from "../pages/WhatsApp/WhatsApp"
import CompanySettingsPage from "../pages/CompanySettings/index"

const userRoutes = [
  { path: "/company-settings", component: <CompanySettingsPage />, roles: ["company-admin", "manager"] },
  { path: "/dashboard", component: <Dashboard />, roles: ["*"] },
  { path: "/profile", component: <UserProfile />, roles: ["*"] },

  { path: "/stock/products", component: <ProductsList />, roles: ["company-admin", "manager"] },
  { path: "/finance/quotes", component: <QuotesList />, roles: ["company-admin", "manager"] },
  { path: "/finance/quotes/create", component: <QuoteCreate />, roles: ["company-admin", "manager"] },
  { path: "/finance/quotes/:id", component: <QuoteDetail />, roles: ["company-admin", "manager"] },

  // //calendar
  { path: "/calendar", component: <Calendar />, roles: ["company-admin", "manager", "agent"] },

  { path: "/chat", component: <Chat />, roles: ["super-admin", "admin", "support", "company-admin", "manager", "agent"] },
  { path: "/kanbanboard", component: <Kanban />, roles: ["company-admin", "manager", "agent"] },

  // // //profile
  { path: "/profile", component: <UserProfile />, roles: ["*"] },

  // //Email
  { path: "/email-inbox", component: <EmailInbox />, roles: ["company-admin", "manager", "agent"] },
  { path: "/email-read", component: <EmailRead />, roles: ["company-admin", "manager", "agent"] },
  { path: "/email-compose", component: <EmailCompose />, roles: ["company-admin", "manager", "agent"] },

  // Admin Routes (System Level)
  { path: "/admin/companies", component: <Companies />, roles: ["super-admin", "admin", "support"] },
  { path: "/admin/companies/:id", component: <CompanyDetail />, roles: ["super-admin", "admin", "support"] },
  { path: "/admin/plans", component: <Plans />, roles: ["super-admin", "admin"] },
  { path: "/admin/system-users", component: <SystemUsers />, roles: ["super-admin", "admin"] },
  { path: "/admin/roles", component: <Roles />, roles: ["super-admin"] },
  { path: "/admin/permissions", component: <Permissions />, roles: ["super-admin"] },
  { path: "/admin/subscriptions/pending", component: <PendingSubscriptions />, roles: ["super-admin", "admin"] },
  { path: "/admin/invoices", component: <Invoices />, roles: ["super-admin", "admin", "support"] },
  { path: "/admin/tickets", component: <TicketsList />, roles: ["super-admin", "admin", "support"] },
  { path: "/admin/tickets/:id", component: <TicketDetail />, roles: ["super-admin", "admin", "support"] },
  { path: "/admin/sales-dashboard", component: <SalesDashboard />, roles: ["super-admin", "admin", "sales"] },
  { path: "/admin/settings", component: <Settings />, roles: ["super-admin"] },

  // Company Level CRM
  { path: "/clients", component: <Customers />, roles: ["company-admin", "manager", "agent", "viewer"] },
  { path: "/clients/:id", component: <CustomerDetail />, roles: ["company-admin", "manager", "agent", "viewer"] },
  { path: "/suppliers", component: <SuppliersList />, roles: ["company-admin", "manager"] },
  { path: "/supplier-invoices", component: <SupplierInvoices />, roles: ["company-admin", "manager"] },
  { path: "/team", component: <CompanyUsers />, roles: ["company-admin", "manager"] },

  // Finances
  { path: "/finance/invoices", component: <InvoicesList />, roles: ["company-admin", "manager"] },
  { path: "/finance/invoices/create", component: <InvoiceCreate />, roles: ["company-admin", "manager"] },
  { path: "/finance/invoices/:id", component: <InvoiceDetail />, roles: ["company-admin", "manager"] },

  { path: "/payments", component: <PaymentsList />, roles: ["company-admin", "manager"] },
  { path: "/whatsapp", component: <WhatsAppPage />, roles: ["super-admin", "admin", "support", "company-admin", "manager", "agent"] },
  { path: "/reports", component: <ChartsAppex />, roles: ["company-admin", "manager"] },

  { path: "/support/tickets", component: <SupportTickets />, roles: ["*"] },
  { path: "/support/tickets/:id", component: <SupportTicketDetail />, roles: ["*"] },

  // //Charts
  { path: "/apex-charts", component: <ChartsAppex />, roles: ["*"] },
  { path: "/charts-chartjs", component: <ChartsJs />, roles: ["*"] },
  { path: "/charts-knob", component: <ChartsKnob />, roles: ["*"] },
  { path: "/sparkline-charts", component: <ChartsSparkLine />, roles: ["*"] },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign />, roles: ["*"] },
  { path: "/icons-ion", component: <Iconion />, roles: ["*"] },
  { path: "/icons-fontawesome", component: <IconFontawesome />, roles: ["*"] },
  { path: "/icons-themify", component: <IconThemify />, roles: ["*"] },
  { path: "/icons-dripicons", component: <IconDripicons />, roles: ["*"] },
  { path: "/icons-typicons", component: <IconTypicons />, roles: ["*"] },

  // // Tables
  { path: "/tables-basic", component: <BasicTables />, roles: ["*"] },
  { path: "/tables-datatable", component: <DatatableTables />, roles: ["*"] },
  { path: "/tables-responsive", component: <ResponsiveTables />, roles: ["*"] },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle />, roles: ["*"] },
  { path: "/maps-vector", component: <MapsVector />, roles: ["*"] },

  // // Forms
  { path: "/form-elements", component: <FormElements />, roles: ["*"] },
  { path: "/form-advanced", component: <FormAdvanced />, roles: ["*"] },
  { path: "/form-editors", component: <FormEditors />, roles: ["*"] },
  { path: "/form-uploads", component: <FormUpload />, roles: ["*"] },
  { path: "/form-validation", component: <FormValidations />, roles: ["*"] },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert />, roles: ["*"] },
  { path: "/ui-buttons", component: <UiButtons />, roles: ["*"] },
  { path: "/ui-badge", component: <UiBadge />, roles: ["*"] },
  { path: "/ui-cards", component: <UiCards />, roles: ["*"] },
  { path: "/ui-carousel", component: <UiCarousel />, roles: ["*"] },
  { path: "/ui-dropdowns", component: <UiDropdown />, roles: ["*"] },
  { path: "/ui-grid", component: <UiGrid />, roles: ["*"] },
  { path: "/ui-images", component: <UiImages />, roles: ["*"] },
  { path: "/ui-lightbox", component: <UiLightbox />, roles: ["*"] },
  { path: "/ui-modals", component: <UiModal />, roles: ["*"] },
  { path: "/ui-pagination", component: <UiPagination />, roles: ["*"] },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips />, roles: ["*"] },
  { path: "/ui-progressbars", component: <UiProgressbar />, roles: ["*"] },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions />, roles: ["*"] },
  { path: "/ui-typography", component: <UiTypography />, roles: ["*"] },
  { path: "/ui-video", component: <UiVideo />, roles: ["*"] },
  { path: "/ui-session-timeout", component: <UiSessionTimeout />, roles: ["*"] },
  { path: "/ui-rangeslider", component: <UiRangeSlider />, roles: ["*"] },
  { path: "/ui-utilities", component: <UiUtilities />, roles: ["*"] },
  { path: "/ui-colors", component: <UiColors />, roles: ["*"] },
  { path: "/ui-offcanvas", component: <UiOffcanvas />, roles: ["*"] },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline />, roles: ["*"] },
  { path: "/pages-invoice", component: <PagesInvoice />, roles: ["*"] },
  { path: "/pages-directory", component: <PagesDirectory />, roles: ["*"] },
  { path: "/pages-blank", component: <PagesBlank />, roles: ["*"] },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    roles: ["*"],
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }